export default __webpack_public_path__ + "static/media/amazon-logo.64a0d895.png";